import {
  VIEWER_REPORT_METER_MONTH_MODEL_LIST,
  VIEWER_REPORT_METER_MONTH_SEARCH,
  VIEWER_REPORT_METER_MONTH_PAGINATION,
  VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_TYPE,
  VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE,
} from "./actionType";

import moment from 'moment';

const initialState = {
  modelDeviceList: [],
  modelSearch: { SEARCH_METER_MONTH: "", UPLOADTYPE_NAME: null, SOURCE_NAME: null, STATUS_FLAG: 0, LOAD_TYPE: 2 }, // UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "",
  dropDownSearchType: null,
  dropDownSearchDataSource: null,
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  // console.log(action);
  switch (action.type) {
    case VIEWER_REPORT_METER_MONTH_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case VIEWER_REPORT_METER_MONTH_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case VIEWER_REPORT_METER_MONTH_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    case VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_TYPE:
      return {
        ...state,
        dropDownSearchType: action.payload,
      }
    case VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE:
      return {
        ...state,
        dropDownSearchDataSource: action.payload,
      }
    default:
      return state;
  }
};
